import { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Loading from "./ui/Loading";
import { NavProvider } from "./contexts/NavContext";
import Blog from "./pages/Blog";

const Home = lazy(() => import("./pages/Home"));
const BoxingGloves = lazy(() => import("./pages/BoxingGloves"));
const Login = lazy(() => import("./pages/Login"));

export default function App() {
  return (
    <NavProvider>
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="account/login" element={<Login />} />
            <Route
              path="collections/boxing-gloves/:category"
              element={<BoxingGloves />}
            />
            <Route path="/blogs" element={<Blog />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </NavProvider>
  );
}
